import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import Seo from "../components/Seo";

const PaymentCancel = () => {
  const { t } = useLang();
  return (
    <div data-testid="payment-cancel-page" className="bg-obsidian min-h-screen">
      <Seo pageKey="shop" />
      <section className="mx-auto flex max-w-3xl flex-col items-center px-6 pt-48 pb-40 text-center md:px-12">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-white/20 text-white/50">
            <XCircle size={28} />
          </div>
          <span className="mt-8 block text-xs uppercase tracking-[0.3em] text-champagne">{t.payment.cancelOverline}</span>
          <h1 className="mt-6 font-serif text-4xl font-light leading-tight text-white md:text-6xl">{t.payment.cancelTitle}</h1>
          <p className="mx-auto mt-6 max-w-xl text-base font-light leading-relaxed text-white/60">{t.payment.cancelSub}</p>
          <div className="mt-12 flex items-center justify-center gap-6">
            <Link to="/shop" data-testid="cancel-back-to-shop" className="flex items-center gap-2 border border-champagne bg-champagne px-7 py-3 text-xs uppercase tracking-[0.2em] text-obsidian transition-colors hover:bg-transparent hover:text-champagne">
              {t.payment.backShop} <ArrowRight size={14} />
            </Link>
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default PaymentCancel;
